import { CommonModule, DOCUMENT } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, Component, Inject, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { IonicModule, ModalController } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Subject, of, switchMap, takeUntil } from "rxjs";

// MODELS
import { GlobalVarsModel } from "@models/ModelGlobalsVar";

import { NewBaseService } from "@providers/newBase.service";
import { DeviceService } from "@services/device.service";
// SERVICES
import { SportService } from "@sports-services/index";

import { CodereFooterComponent } from "@components/mso/footer/codere-footer/codere-footer";
// COMPONENTS
import { Login } from "@shared-mso-pages/login/login";

@Component({
  selector: "codere-fantasy-page",
  templateUrl: "codere-fantasy.page.html",
  styleUrls: ["codere-fantasy.page.scss"],
  host: {
    class: "codere-fantasy",
  },
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, TranslateModule, CodereFooterComponent],
})
export class CodereFantasyPage {
  globalVars: GlobalVarsModel;
  router = inject(Router);
  deviceService = inject(DeviceService);
  newBaseService = inject(NewBaseService);
  translate = inject(TranslateService);
  sportService = inject(SportService);
  videoUrl: any;
  isMobile = false;

  iframeSrc: any = "about-blank";
  tempIframeSrc: any;
  gameUrl: string;
  modalController = inject(ModalController);

  private readonly unsubscribe$ = new Subject();

  constructor(
    @Inject(DOCUMENT) private dom: Document,
    public sanitizer: DomSanitizer,
  ) {
    this.isMobile = this.deviceService.isMobile();

    this.newBaseService.getVars
      .pipe(
        switchMap((data: GlobalVarsModel) => {
          this.globalVars = data;
          return of(null);
        }),
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();

    this.tempIframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://codere.dgafantasy.com/league?operatorKey=${this.globalVars.CodereFantasyOperatorKeyProd}&language=es`,
    );

    this.getCodereFantasyCode();
  }

  ngOnInit() {
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
  }

  getCodereFantasyCode() {
    if (this.globalVars.user.logged) {
      this.sportService
        .getCodereFantasyCode()
        .pipe(
          switchMap((data) => {
            const currency = "eur";
            this.gameUrl = `${this.globalVars.CODERE_FANTASY_HP_URL}&code=${data.Code}&currency=${currency}&language=es`;
            this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.gameUrl);
            return of(null);
          }),
        )
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe();
    }
  }

  async openLogin() {
    if (!this.globalVars.user.logged) {
      const login = await this.modalController.create({
        component: Login,
      });
      login.present();
      login.onDidDismiss().then(() => {
        if (this.globalVars.user.logged) {
          this.getCodereFantasyCode();
        }
      });
    }
  }
}
